import { ImageName } from "@mcleod/images";
import { Button } from "../button/Button";
import { ButtonProps } from "../button/ButtonProps";
import { ButtonVariant } from "../button/ButtonVariant";
import { ClickEvent } from "../../events/ClickEvent";
import { TableRow } from "./TableRow";

export class ExpandButton extends Button {
    private tableRow: TableRow;

    constructor(tableRow: TableRow, id: string) {
        super({
            color: "strokePrimary",
            enabled: tableRow.table._designer == null,
            focusable: false,
            id,
            imageHeight: 20,
            imageWidth: 20,
            margin: 0,
            padding: 8,
            variant: ButtonVariant.round
        });
        this.tableRow = tableRow;
        this.setProps(this.buttonPropsForAlignment);
        this.addClickListener(() => {
            this.tableRow.expanded = !this.tableRow.expanded;
        });

        // Prevent double-click events from propagating to the table row
        this.addDblClickListener((event: ClickEvent) => {
            event.consume();
        });
    }

    private get buttonPropsForAlignment(): Partial<ButtonProps> {
        return {
            imageName: this.tableRow.displayingExpandCellRight() ? ImageName.chevronLeft : ImageName.chevronRight
        };
    }

    public sync() {
        this.setProps(this.buttonPropsForAlignment);
        this.visible = this.tableRow.expandable;
        this.syncRotation();
    }

    public syncRotation() {
        if (this.tableRow.displayingExpandCellRight()) {
            this.imageRotation = this.tableRow.expanded ? -90 : 0;
        } else {
            this.imageRotation = this.tableRow.expanded ? 90 : 0;
        }
    }
}
